import React from 'react';
import { useContext } from 'react';
import localize from '../i18n/localize';
import LocalizedContext from '../i18n/LocalizedContext';

import './NoData.css';

const NoData = () => {
    const lang = useContext(LocalizedContext);
    return (
        <div className='NoData'>
            <br/>
            <b>{localize(lang, 'noData')}</b>
            <br/>
            <br/>
            {localize(lang, 'unexpected')}
        </div>
    );
}

export default NoData;